import { useQuery } from "@tanstack/react-query";
import api from "../../../api/api";
import { QUERY_ADMIN_DASHBOARD_KEY } from "../../../api/queryKeys";
import { QueryAdminDashboardResponse } from "../../../types";

export const getDashboardData = () =>
  api
    .get<QueryAdminDashboardResponse>(QUERY_ADMIN_DASHBOARD_KEY)
    .then((res) => res.data);

export default function useGetDashboard({
  onSuccessHandler,
}: {
  onSuccessHandler: () => void;
}) {
  return useQuery([QUERY_ADMIN_DASHBOARD_KEY], getDashboardData, {
    onSuccess: (data) => {
      if (onSuccessHandler) {
        onSuccessHandler();
      }
    },
  });
}
